import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { PrimaryActionWithNotification } from "@clientFrontend/features/publication/components/PrimaryActionWithNotification";
import type { ShopContent } from "@clientFrontend/features/publication/components/ShopContentDetail/type";
import { ShopContentDetail } from "@clientFrontend/features/publication/components/ShopContentDetail";
import { PublicationArticleContainer } from "@clientFrontend/features/publication/components/PublicationArticleContainer";
import * as styles from "./styles.css";

type Props = {
  editUrl: string;
  canEdit: boolean;
  shopContent: ShopContent;
  dummyImgPath: string;
  site: "biyo" | "kaigo";
  isShikaPlan: boolean;
};

export const ShopContentShow: FC<Props> = ({
  editUrl,
  canEdit,
  shopContent,
  dummyImgPath,
  site,
  isShikaPlan,
}) => {
  return (
    <PublicationArticleContainer>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        店舗情報
      </Heading>
      <PrimaryActionWithNotification
        text="編集する"
        url={editUrl}
        iconName="edit"
        cannotActionType="inactive"
        canAction={canEdit}
      >
        <p className={styles.approvingDuration}>
          ご申請から反映までの目安&nbsp;
          <span className={styles.approvingDurationExp}>最大3営業日以内</span>
        </p>
      </PrimaryActionWithNotification>
      <ShopContentDetail
        editUrl={editUrl}
        canEdit={canEdit}
        shopContent={shopContent}
        dummyImgPath={dummyImgPath}
        site={site}
        isShikaPlan={isShikaPlan}
      />
    </PublicationArticleContainer>
  );
};
